export const getRecipePickerModalSteps = (t) => [
    {
        target: '[data-tour="rpm-modal"]',
        placement: 'center',
        title: t('tour.recipePickerModal.step-welcome-title'),
        content: t('tour.recipePickerModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="rpm-toolbar"]',
        title: t('tour.recipePickerModal.step-toolbar-title'),
        content: t('tour.recipePickerModal.step-toolbar-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="rpm-body"]',
        title: t('tour.recipePickerModal.step-grid-title'),
        content: t('tour.recipePickerModal.step-grid-content'),
        disableBeacon: true,
    },
];
